import { get, isArray, isEmpty, isNil } from 'lodash';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwCheckbox from 'viewmodel/AwCheckboxViewModel';
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwLink from 'viewmodel/AwLinkViewModel';
import { publish } from 'js/accEventBus';
import modelPropertyService from 'js/modelPropertyService';

const DES_HIDE = 'des-hide';
const DES_SEARCH_FACET_LOADING = 'des-search-facet-container';
// Default facet size limit is 5.
// Array length start from 0, for eg, [0, 1, 2, 3, 4] = 5 elements
const DEFAULT_PAGE_SIZE = 4;
const getDisplayName = (viewModel, bucket) => {
    let displayName = '';
    const bucketValue = get(bucket, 'value');
    if (isNil(bucketValue)) {
        displayName = `${bucket.key} (${bucket.doc_count})`;
    } else if (bucketValue === 'me') {
        displayName = `${viewModel.i18n.myHome} (${bucket.doc_count})`;
    } else {
        displayName = `${bucket.value} (${bucket.doc_count})`;
    }
    return displayName;
}

const toggleDesHideClass = (showMore, showLess) => {
    document.getElementsByClassName(showMore)[0].classList.toggle(DES_HIDE);
    document.getElementsByClassName(showLess)[0].classList.toggle(DES_HIDE);
}
const buildCheckbox = (section, paginationSize) => {
    const panelProps = {
        attributes: {
            style: {
                display: 'none'
            }
        }
    };
    const sectionName = section.name.replace(/ /gi, '-');
    return section.buckets.map((prop, bucketIndex) => {
        let className = '';
        if (bucketIndex > paginationSize) {
            className = `des-hide`;
        }
        return (
            <AwCheckbox className={`${sectionName}.item.${bucketIndex} ${className} des-${sectionName}`} {...prop} {...panelProps}></AwCheckbox>
        );
    });
}

const showMoreFacet = (sectionBucketLength, sectionName, params) => {
    let counter = params.pageLimit;
    for (let i = 0; i < DEFAULT_PAGE_SIZE; i++) {
        const internalCounter = counter + 1;
        const classRef = document.getElementsByClassName(`${sectionName}.item.${internalCounter}`);
        if (classRef && classRef.length) {
            counter = internalCounter;
            for (let j = 0; j < classRef.length; j++) {
                classRef[j].classList.remove(DES_HIDE);
            }
            params.pageLimit = counter;
        }
    }
    if (sectionBucketLength <= DEFAULT_PAGE_SIZE || sectionBucketLength - 1 === counter) {
        // Hide show more and display show less
        toggleDesHideClass(`${sectionName}-show-more`, `${sectionName}-show-less`);
    }
}

const hideElement = (sectionName, paginationCount, params) => {
    for (let i = DEFAULT_PAGE_SIZE; i > 0; i--) {
        const lastNode = paginationCount - 1;
        const classRef = document.getElementsByClassName(`${sectionName}.item.${lastNode}`);
        if (classRef.length) {
            for (let j = 0; j < classRef.length; j++) {
                classRef[j].classList.add(DES_HIDE);
            }
            params.pageLimit = params.pageLimit - 1;
        }
        paginationCount = lastNode;
    }
    return paginationCount;
}

const showLessFacet = (sectionName, params) => {
    const hiddenFacet = document.getElementsByClassName(`des-${sectionName} ${DES_HIDE}`);
    const visibleFacet = document.getElementsByClassName(`des-${sectionName}`);
    let paginationCount = visibleFacet.length;
    if (hiddenFacet && hiddenFacet.length > 0) {
        paginationCount = visibleFacet.length - hiddenFacet.length;
    }
    paginationCount = (paginationCount / 2);
    const showMoreClass = `${sectionName}-show-more`;
    const showLessClass = `${sectionName}-show-less`;
    if (DEFAULT_PAGE_SIZE === paginationCount - 1) {
        // Hide show more and display show less
        toggleDesHideClass(showMoreClass, showLessClass);
    } else {
        paginationCount = hideElement(sectionName, paginationCount, params);
        if (DEFAULT_PAGE_SIZE === paginationCount - 1 || DEFAULT_PAGE_SIZE === paginationCount || paginationCount < DEFAULT_PAGE_SIZE) {
            toggleDesHideClass(showMoreClass, showLessClass);
        }
    }
}

const getFacetToggleHtml = (params) => {
    const { bucketLength, bucketsRendered } = params;

    // Array length start from 0.
    const reducedBucketLength = bucketLength - 1;
    if (reducedBucketLength > DEFAULT_PAGE_SIZE && bucketsRendered && Array.isArray(bucketsRendered)) {
        const { sectionName, showMore, showLess } = params;
        const showLessFacetHandler = () => {
            showLessFacet(sectionName, params);
        };
        const showMoreFacetHandler = () => {
            showMoreFacet(bucketLength, sectionName, params);
        };

        const showMoreProp = {
            fielddata: modelPropertyService.createViewModelProperty({
                displayName: showMore,
                type: 'STRING',
                isRequired: false
            })
        };
        const showLessProp = {
            fielddata: modelPropertyService.createViewModelProperty({
                displayName: showLess,
                type: 'STRING',
                isRequired: false
            })
        };
        const desGetHtml = () => {
            return (
                <>
                    <AwLink className={`${sectionName}-show-more`} {...showMoreProp} action={showMoreFacetHandler} ></AwLink>
                    <AwLink className={`${sectionName}-show-less des-hide`} {...showLessProp} action={showLessFacetHandler} ></AwLink>
                </>
            );
        };
        bucketsRendered.push(desGetHtml());
    }
}

export const updateFacets = (viewModel, updatedFacets) => {
    const {
        data,
        dispatch,
    } = viewModel;
    const selectedFacets = updatedFacets.selectedFacets;
    data.query = updatedFacets.query;
    data.facets = [];
    if (isArray(updatedFacets.facets)) {
        const sections = updatedFacets.facets.map((facets) => {
            const name = Object.keys(facets)[0];
            const buckets = get(facets, `${name}.buckets`, []);
            const section = {
                name,
                buckets: []
            }
            if (isEmpty(buckets)) {
                const appliedFacets = selectedFacets.filter(f => f.facetField === name);
                if (!isEmpty(appliedFacets)) {
                    appliedFacets.forEach(appliedFacet => {
                        const displayName = `${appliedFacet.facetValue} (0)`;
                        const facetType = get(appliedFacet, 'type');
                        const prop = createFacetProp(displayName, name, appliedFacet.facetValue, true, data, dispatch, facetType);
                        section.buckets.push(prop);
                        data.facets.push({ facetField: prop.facetField, facetValue: prop.facetValue, facetType: facetType });
                    });
                }
            }
            buckets.map(bucket => {
                const displayName = getDisplayName(viewModel, bucket)
                const prop = createFacetProp(displayName, name, bucket.key, bucket.isSelected, data, dispatch, bucket.type);
                section.buckets.push(prop);
                if (bucket.isSelected) {
                    data.facets.push({ facetField: prop.facetField, facetValue: prop.facetValue, facetType: bucket.type });
                }
            });
            return section;
        });
        data.sections = sections;
    }
    dispatch({
        path: 'data',
        value: {
            ...data
        }
    });
};

export const searchFacetsRenderFunction = ({ viewModel }) => {
    const data = viewModel.data;
    const queryString = get(viewModel, 'data.query', '');
    data.sections = data.sections.filter(ele => !isNil(ele) && get(ele, 'name') !== 'Collaborationspace' && !isNil(ele.buckets) && !isEmpty(ele.buckets));

    const getLocalizedFacetName = (facetName) => {
        return facetName.toLowerCase().split(" ").reduce((s, c) => s + (c.charAt(0).toUpperCase() + c.slice(1)));
    }
    let sections = data.sections.map((section, sectionIndex) => {
        if (isEmpty(section.buckets)) {
            return null;
        }

        const sectionName = section.name.replace(/ /gi, '-');
        const bucketsRendered = buildCheckbox(section, DEFAULT_PAGE_SIZE);
        const sectionBucketLength = get(section, 'buckets', []).length;
        const params = {
            bucketLength: sectionBucketLength,
            bucketsRendered: bucketsRendered,
            pageLimit: DEFAULT_PAGE_SIZE,
            sectionName: sectionName,
            showMore: viewModel.i18n.showMore,
            showLess: viewModel.i18n.showLess
        };
        getFacetToggleHtml(params);
        const displayName = get(viewModel, `i18n.${getLocalizedFacetName(section.name)}`, section.name);
        return (
            <AwPanelSection caption={displayName}>
                {bucketsRendered}
            </AwPanelSection>
        );
    });
    sections = sections.filter(section => !isNil(section));
    if (!isEmpty(sections)) {
        const panelProps = {
            attributes: {
                style: {
                    height: '100%'
                }
            }
        };

        const ixEnabled = window.ixEnabled;
        const clearButtonProps = {
            id: 'id',
            'aria-label': 'btn',
            type: 'button',
            action: () => {
                data.facets = [];
                publish('des-search-filter.clear', { facets: data.facets });
            },
            size: 'auto',
            buttonType: 'base'
        };
        const applyButtonProps = {
            id: 'id',
            'aria-label': 'btn',
            type: 'button',
            action: () => {
                publish('des-search-filter.apply', { facets: data.facets });
            },
            size: 'auto'
        };

        if (queryString.length > 0) {
            if (ixEnabled === 'true') {
                return (
                    <AwPanel className='search-box-acc-ix-brand-facet-panel'>
                        <AwPanelBody>
                            {sections}
                        </AwPanelBody>
                        <AwPanelFooter>
                            <AwFlexRow height='12' justify='space-evenly'>
                                <button type="button" {...clearButtonProps} className='search-box-acc-ix-brand-button-secondary' onClick={() => {
                                    data.facets = [];
                                    publish("des-search-filter.clear", { facets: data.facets });
                                }}
                                >{viewModel.i18n.clearAll}</button>
                                <button type="button" {...applyButtonProps} className='search-box-acc-ix-brand-button' onClick={() => {
                                    publish("des-search-filter.apply", { facets: data.facets });
                                }}
                                >{viewModel.i18n.apply}</button>
                            </AwFlexRow>
                        </AwPanelFooter>
                    </AwPanel>
                );
            } else {
                return (
                    <AwPanel {...panelProps}>
                        <AwPanelBody>
                            {sections}
                        </AwPanelBody>
                        <AwPanelFooter>
                            <AwFlexRow height='12' justify='space-evenly'>
                                <AwButton {...clearButtonProps}>{viewModel.i18n.clearAll}</AwButton>
                                <AwButton {...applyButtonProps}>{viewModel.i18n.apply}</AwButton>
                            </AwFlexRow>
                        </AwPanelFooter>
                    </AwPanel>
                );
            }
        }
    }
    return null;
};

export const createFacetProp = (displayName, facetField, facetValue, isChecked, data, dispatch, facetType) => {
    const prop = {
        fielddata: {
            propertyDisplayName: displayName,
            type: 'BOOLEAN',
            isRequired: 'false',
            isEditable: 'true',
            labelPlacement: 'end'
        },
        onChange: (ev) => {
            const checked = ev.target.checked;
            prop.checked = checked;
            if (isNil(data.facets)) {
                data.facets = [];
            }
            if (checked) {
                data.facets.push({ facetField: prop.facetField, facetValue: prop.facetValue, facetType: facetType, facetName: displayName });
            } else {
                const idx2 = data.facets.findIndex(facet => facet.facetValue === prop.facetValue);
                data.facets.splice(idx2, 1);
            }
            dispatch({
                path: 'data',
                value: {
                    ...data
                }
            });
        },
        facetField,
        facetValue,
        selected: false,
        checked: isChecked
    };
    return prop;
};

export const searchFacetsOnMountFunction = () => {
    handleIxBranding();
}

let popupObserver = null;

export function handleIxBranding() {
    if (!popupObserver) {
        popupObserver = new MutationObserver(() => {

            const ixEnabled = window.ixEnabled;
            
            const searchPanelBody = document.querySelectorAll('.aw-base-scrollPanel.sw-column.aw-layout-panelContent');
            const titles = document.querySelectorAll('.sw-row.sw-sectionTitleContainer');
            searchPanelBody.forEach(panel => {
                if (ixEnabled === "true" || ixEnabled === true) {
                    panel.classList.add('search-box-acc-ix-brand-facet-panel-body');
                } else {
                    panel.classList.remove('search-box-acc-ix-brand-facet-panel-body');
                }
            });

            titles.forEach(t => {
                if (ixEnabled === "true" || ixEnabled === true) {
                    t.classList.add('search-box-acc-ix-brand-facet-title');
                } else {
                    t.classList.remove('search-box-acc-ix-brand-facet-title');
                }
            })

            const checkboxes = document.querySelectorAll('.sw-checkbox-val');
            checkboxes.forEach(cb => {
                if (ixEnabled === "true" || ixEnabled === true) {
                    cb.classList.add('search-box-acc-ix-brand-checkbox');
                } else {
                    cb.classList.remove('search-box-acc-ix-brand-checkbox');
                }
            });
        });

        popupObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
}
export {
    showMoreFacet,
}

